import { useEffect, useState } from 'react';
import axios from 'axios';
import './Annoncements.scss';
import Marquee from 'react-fast-marquee';
import { useTranslation } from 'react-i18next';
import { API_ENDPOINTS } from '../../assets/api/endpoints';
import dayjs from 'dayjs';
import { useConfigurationContext } from '../../store/configurationContext';
import { useMainContext } from '../../store/MainContext';
const DATE_TIME_FORMAT = 'MMM D, YYYY h:mm A';
export default function AnnoncemetBanner() {
	const { configurationState } = useConfigurationContext();
	const { mainState } = useMainContext();
	const [holidays, setHolidays] = useState([]);
	const [annoncementArr, setAnnocementsArr] = useState([]);
	const [annoncements, setAnnocements] = useState<string[]>([]);
	const { t } = useTranslation();
	useEffect(() => {
		if (mainState.isLoggedIn) {
			getAnnoncementsBanner();
		}
		if (!mainState.isLoggedIn) setAnnocements([]);
	}, [mainState.isLoggedIn]);

	useEffect(() => {
		const holidaysArr = holidays.map((item: any) => {
			if (item.type === 'W') {
				return t<string>('weekdayHoliday', {
					weekdays: item.weekDays.map((item: string) => t(item)).join(', '),
					name: item.name,
				});
			} else {
				return t<string>('dateRangeHoliday', {
					startDate: dayjs(item.startDate).format(DATE_TIME_FORMAT),
					endDate: dayjs(item.endDate).format(DATE_TIME_FORMAT),
					name: item.name,
				});
			}
		});
		const annocementsArrays = annoncementArr.map((item: any) =>
			t<string>('annoncement', {
				from: dayjs(item.startDate).format(DATE_TIME_FORMAT),
				to: dayjs(item.endDate).format(DATE_TIME_FORMAT),
			}),
		);
		setAnnocements([...annocementsArrays, ...holidaysArr]);
	}, [mainState.language, holidays, annoncementArr]);
	const getAnnoncementsBanner = async () => {
		const holidays = await axios.get(API_ENDPOINTS.isTodayHoliday);
		const annoncements = await axios.get(API_ENDPOINTS.getAnnoncement);
		setAnnocementsArr(annoncements.data);
		setHolidays(holidays.data.comingHolidays);
	};
	if (!annoncements.length) {
		return null;
	}
	const themeColor = configurationState.find((item) => item.configKey === 'theme_color')?.value || '';
	const secondary_color = configurationState.find((item) => item.configKey === 'secondary_color')?.value || '';
	return (
		<div
			dir='ltr'
			id='annoncement-banner'
			style={{
				width: '100%',
				height: '35px',
				boxShadow: 'white 0px 0px 5px',
				backgroundColor: themeColor,
				opacity: '.8',
				color: secondary_color,
				display: 'flex',
			}}
		>
			{annoncements.length === 1 ? (
				<div className='single-announcement'>{annoncements[0]}</div>
			) : (
				<Marquee autoFill={true}>
					{annoncements.map((announcement, index) => (
						<>
							<span key={index} className='marquee-item mx-5'>
								{announcement}
							</span>
							{<span>|</span>}
						</>
					))}
				</Marquee>
			)}
		</div>
	);
}
